import * as React from 'react';
import useAppendScript from 'hooks/useAppendScript';
import { TV_FUNDAMENTAL_ANALYSIS_SRC, TV_FUNDAMENTAL_ANALYSIS_PROPS } from 'constants/tradingview';

const SCRIPT_SRC = TV_FUNDAMENTAL_ANALYSIS_SRC;
const WIDGET_PROPS = { ...TV_FUNDAMENTAL_ANALYSIS_PROPS };
const NODE_ID = 'tv-fundamental-analysis';

const FundamentalAnalysisWidget: React.FC<React.PropsWithChildren<{ activeTicker: string; path: string }>> = ({
  path,
  activeTicker,
}) => {
  const largeChartUrl = `${process.env.ROOT_URL}${path}?ticker=${activeTicker}&tab=screener`;
  const code = JSON.stringify({ ...WIDGET_PROPS, symbol: activeTicker, largeChartUrl });

  useAppendScript({
    src: SCRIPT_SRC,
    nodeId: NODE_ID,
    code,
  });

  return <div className="h-full" id={NODE_ID}></div>;
};

export default FundamentalAnalysisWidget;
